export const SITE_URL = process.env.SITE_URL || `https://truelayer.com`;
export const CONFIG_ENABLE_ANIMATIONS =
  process.env.CONFIG_ENABLE_ANIMATIONS === "true";
